import YYSwitch from './switch'

export default YYSwitch